import { NgModule } from '@angular/core';
import { ShineBorderDirective } from './shine-border.directive';

@NgModule({
    declarations: [
        ShineBorderDirective
    ],
    imports: [],
    exports: [
        ShineBorderDirective
    ]
})
export class NcShineBorderModule { }